/**
 * The status of a payment transaction (present in POM redirect - reflected in the responseCode)
 * Can be used to show the status of a payment transaction to the user
 */
export enum TransactionStatus {
  /**
   * The payment was successful
   */
  COMPLETED = 'COMPLETED',
  /**
   * The payment is being processed
   */
  PROCESSING = 'PROCESSING',
  /**
   * The payment was refused
   */
  REFUSED = 'REFUSED',
}

/**
 * Status of a payment linked to an order
 */
export enum PaymentStatus {
  /**
   * The payment is not found
   */
  NOT_FOUND = 'NOT_FOUND',
  /**
   * The payment was revoked
   */
  REVOKED = 'REVOKED',
  /**
   * The payment is unpaid
   */
  UNPAID = 'UNPAID',
  /**
   * The payment was completed
   */
  COMPLETED = 'COMPLETED',
  /**
   * The payment was refunded
   */
  REFUNDED = 'REFUNDED',
  /**
   * The payment was partially refunded
   */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  /**
   * The payment was marked
   */
  MARKED = 'MARKED',
  /**
   * The payment is being processed
   */
  PROCESSING = 'PROCESSING',
  /**
   * The payment is scheduled
   */
  SCHEDULED = 'SCHEDULED',
}

/**
 * Response from the payment status endpoint
 */
export type PaymentStatusResponse = {
  /**
   * The order id
   */
  orderId: number

  /**
   * The external id of the payment
   */
  externalId: string

  /**
   * The status of the payment
   */
  status: PaymentStatus

  /**
   * The amount of the payment
   */
  amount: number

  /**
   * The currency of the payment
   */
  currency: string

  /**
   * The created at date
   */
  createdAt: Date

  /**
   * The updated at date
   */
  updatedAt: Date
}
